import "./style.scoped.css";

const InfoItem = (props) => {
  const { title, content } = props;
  return (
    <div>
      <div className="labelText title">{title}</div>
      <div className="content">{content}</div>
    </div>
  );
};

export default InfoItem;
